import CCRRateBox from './CCRRateBox';
export default CCRRateBox;



// WEBPACK FOOTER //
// ./src/components/common/CCRRateBox/index.js